import { render } from "./LeadScoreBadge.vue?vue&type=template&id=b534f650&scoped=true"
import script from "./LeadScoreBadge.vue?vue&type=script&lang=js"
export * from "./LeadScoreBadge.vue?vue&type=script&lang=js"

import "./LeadScoreBadge.vue?vue&type=style&index=0&id=b534f650&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b534f650"]])

export default __exports__